/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import BasicInfo from "./components/BasicInfo";
import { useUploadImage } from "hook/services";
import { useAppServices } from "hook/services";
import timezones from "timezones.json";
import { useAgencyInfo } from "../../../../context/agency";
import { useEffect, useState } from "react";
function Settings() {
  const uploadImage = useUploadImage();
  const AppService = useAppServices();
  const [agency, Update] = useAgencyInfo();
  const [timezones_data, settimezones_data] = useState([]);
  const [agency_data, setagency_data] = useState([]);
  const [logo, setlogo] = useState("");
  const [whitelabel_logo, setwhitelabel_logo] = useState("");
  const [chatapp_logo, setChatapp_logo] = useState("");
  const [ghl_connect_logo, setGhl_connect_logo] = useState("");
  const [hero_image, sethero_image] = useState(agency?.Customization?.hero_image || "");
  const [bussiness_name, setbussiness_name] = useState(agency?.profile?.bussiness_name);
  const [loading, setLoading] = useState(false);
  const handleImage = async (file, type) => {
    if (type == "logo") {
      setlogo(file);
    } else if (type == "ghl_connect_logo") {
      setGhl_connect_logo(file);
    } else if (type == "chatapp_logo") {
      setChatapp_logo(file);
    } else if (type == "whitelabel_logo") {
      setwhitelabel_logo(file);
    }
    if (type == "logo") {
      setlogo(file);
    } else {
      sethero_image(file);
    }
  };

  const onLoad = () => {
    var temp_time = [];
    for (let index = 0; index < timezones.length; index++) {
      const element = timezones[index];

      var temp = {
        label: element.text,
        value: element.value,
      };
      temp_time.push(temp);
    }
    settimezones_data(temp_time);
  };
  useEffect(() => {
    onLoad();
  }, []);

  return (
    <BasicInfo
      handleImage={handleImage}
      loading={loading}
      setbussiness_name={setbussiness_name}
      bussiness_name={bussiness_name}
      timezones_data={timezones_data}
    />
  );
}

export default Settings;
